import { Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { SicotService } from '../../sicot.service';
import { Distretto } from '../../types/Distretto';
import { CommonModule } from '@angular/common';

export interface DistrettoDialogData {
  /** Se presente = modifica, altrimenti = crea. */
  distretto?: Distretto | null;
}

@Component({
  selector: 'app-distretto-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
  ],
  templateUrl: './distretto-dialog.component.html',
  styleUrl: './distretto-dialog.component.css',
})
export class DistrettoDialogComponent {
  private readonly fb = inject(FormBuilder);
  private readonly sicot = inject(SicotService);
  private readonly dialogRef = inject(MatDialogRef<DistrettoDialogComponent>);
  private readonly data = inject<DistrettoDialogData>(MAT_DIALOG_DATA);

  form: FormGroup;
  isEdit: boolean;
  submitting = false;
  errorMessage: string | null = null;

  constructor() {
    const d = this.data?.distretto;
    this.isEdit = d != null;
    this.form = this.fb.group({
      codice: [{ value: d?.codice ?? null, disabled: this.isEdit }, [Validators.required]],
      descrizione: [d?.descrizione ?? '', [Validators.required]],
    });
  }

  submit(): void {
    if (this.form.invalid || this.submitting) return;
    this.errorMessage = null;
    this.submitting = true;
    const codice = this.form.getRawValue().codice as number;
    const descrizione = this.form.getRawValue().descrizione as string;

    if (this.isEdit) {
      this.sicot.updateDistretto(codice, { descrizione }).subscribe({
        next: (updated) => {
          this.dialogRef.close(updated);
        },
        error: (err) => {
          this.errorMessage = err?.error?.message ?? 'Errore durante l\'aggiornamento.';
          this.submitting = false;
        },
      });
    } else {
      this.sicot.createDistretto({ codice, descrizione }).subscribe({
        next: (created) => {
          this.dialogRef.close(created);
        },
        error: (err) => {
          this.errorMessage = err?.status === 409
            ? 'Un distretto con questo codice esiste già.'
            : (err?.error?.message ?? 'Errore durante la creazione.');
          this.submitting = false;
        },
      });
    }
  }
}
